/**
 * Map language names from JWT token to i18n language codes
 * @param languageName - Language name (e.g., "English", "German")
 * @returns i18n language code (e.g., "en", "de")
 */
export const mapLanguageToCode = (languageName?: string): string => {
  if (!languageName) return 'en';

  const normalized = languageName.toLowerCase().trim();
  const languageMap: Record<string, string> = {
    english: 'en',
    german: 'de',
    japanese: 'ja',
    french: 'fr',
    korean: 'ko',
  };

  return languageMap[normalized] || 'en';
};
